import React, {  useRef, useEffect, useState,useCallback } from 'react'; 
import { useDispatch } from "react-redux";  
import { useTranslation } from "react-i18next"; 
import Box from '@mui/material/Box'; 
import Container from '@mui/material/Container';
import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css"; 
import { warningErrorAction } from "actions/ErrorActions";
import { DropzoneAreaBase } from 'material-ui-dropzone'; 
import image1 from "components/photos/sidebars/takephoto.jpeg";
import "css/generalSettings.css";
import "css/customDialog.css";
import PropTypes from 'prop-types'; 
 
const initialArticleImages = [{
  "id":0,
  "indexrowsarticleimage":0,
  "titlees":"",
  "titleen":"",
   "filename":"",
  "createdate":new Date(),
  "datafile":"",
  "type":""   
}];

const ArticleImageCreateOrEditArticleImage = ({
  openEditRowArticleImage,
  setOpenEditRowArticleImage,
  openEditNewArticleImage,
  setOpenEditNewArticleImage,
  formArticle,
  setFormArticle,
  editRowArticleImage,
  setEditRowArticleImage}) => {
  const {t} = useTranslation(['listDataArticles']);
  const [newArticleImage,setNewArticleImage]= useState(initialArticleImages);
  const [errorsArticleImage, setErrorsArticleImage] = useState({});
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [files, setFiles] = useState([]);
  const videoRef = useRef(null);
  const canvasRef = useRef(null); 
  const dispatch = useDispatch(); 
    
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' ) {
        if (showCameraModal) {
          // 👈 Si está abierta la cámara, paramos el stream y cerramos solo el modal
          const video = videoRef.current;
          if (video && video.srcObject) {
            video.srcObject.getTracks().forEach(track => track.stop());
          }
          setShowCameraModal(false);
          return; // no cierres todo el Drawer
        }
        if (openEditRowArticleImage) {
          // reset completo del formulario + cerrar Drawer
          setNewArticleImage({
            id: 0,
            indexrowsarticleimage: 0,
            titlees: "",
            titleen: "",
            filename: "",
            createdate: new Date(),
            datafile: "",
            type: ""
          });
          setEditRowArticleImage(initialArticleImages);
          setErrorsArticleImage({});
          setFiles([]);
          setOpenEditRowArticleImage(false);
          setOpenEditNewArticleImage(false);
        }
      }
    },[
      setNewArticleImage,
      setErrorsArticleImage,
      showCameraModal,
      setShowCameraModal,
      openEditRowArticleImage,
      setOpenEditRowArticleImage,
      setOpenEditNewArticleImage,
      setEditRowArticleImage]
  );

  const handleCloseNewArticleImage = () => {
    if (showCameraModal) {
      // 👈 Si está abierta la cámara, paramos el stream y cerramos solo el modal
      const video = videoRef.current;
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop());
      }
      setShowCameraModal(false);
      return; // no cierres todo el Drawer
    }
    // reset completo del formulario + cerrar Drawer
    setNewArticleImage({
      id: 0,
      indexrowsarticleimage: 0,
      titlees: "",
      titleen: "",
      filename: "",
      createdate: new Date(),
      datafile: "",
      type: ""
    });
    setEditRowArticleImage(initialArticleImages);
    setErrorsArticleImage({});
    setFiles([]);
    setOpenEditRowArticleImage(false);
    setOpenEditNewArticleImage(false);
    
  };

  const handleChangeNewArticleImage = (e) => {
    const { name, value } = e.target;
    setNewArticleImage(newArticleImage => ({
      ...newArticleImage,
      [name]: value,
    }));   
  };
  
  const handleBlurNewArticleImage = (e) => {
    handleChangeNewArticleImage(e);
    setErrorsArticleImage(validateFormArticleImage());
  };

  const toggleDrawerNewArticleImage  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseNewArticleImage();
    }
  }

  const handleAddImage = (newFiles) => {
    const norm = newFiles.map(f => {
      if (f.file) return f;
      // si viene solo con data, lo convertimos
      const fname = `camera-${Date.now()}.jpg`;
      const file = dataURLtoFile(f.data, fname);
      return { ...f, file };
    });
    setFiles([...norm]);
     setNewArticleImage(newArticleImage => ({
      ...newArticleImage, 
      titlees:norm[0]?.file?.name ?? '',
      titleen:norm[0]?.file?.name ?? ''
    }));   
  };
 
  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime, lastModified: Date.now() });
  };

  const handleAddFileImage = (newFiles) => {
    setFiles([...newFiles]);
    setNewArticleImage(newArticleImage => ({
      ...newArticleImage, 
      titlees:newFiles[0]?.file?.name ?? '',
      titleen:newFiles[0]?.file?.name ?? ''
    })); 
  };

  const handleDeleteFileImage = (deleted) => {
    setFiles(files.filter(f => f !== deleted));
  };
  
  const validateFormArticleImage = () => {
    let errorsArticleImage = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (regexInvalidCharacters.test(newArticleImage.titlees)) {
      errorsArticleImage.titlees = 'Text_TextNoValid';
    } else{
      if (newArticleImage.titlees==="" || newArticleImage.titlees===null){
        errorsArticleImage.titlees = 'Text_Titlees_NameRequired';
      }
    } 
    if (regexInvalidCharacters.test(newArticleImage.titleen)) {
      errorsArticleImage.titleen = 'Text_TextNoValid';
    } else {
      if (newArticleImage.titleen==="" || newArticleImage.titleen===null){
        errorsArticleImage.titleen = 'Text_Titleen_NameRequired';
      }
    }  
    return errorsArticleImage; 
  };
 
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result.split(',')[1]; // solo el contenido base64
        resolve(base64);
      };
    reader.onerror = (error) => reject(error);
    }
  );

  const buildUpdatedFiles = async () => {
    const updatedFiles = await Promise.all(
      files.map(async (item, index) => {
        const file = item.file || item; // por si viene directo del input
        const base64 = await toBase64(file);
        return {
          id: index,
          filename: file.name,
          createdate: file.lastModified,
          datafile: base64,
          type: file.type
        };
      })
    );
    return updatedFiles;
  }; 

  const handleSubmitNewArticleImage = async () => {
     if (showCameraModal) {
      // 👈 Si está abierta la cámara, paramos el stream y cerramos solo el modal
      const video = videoRef.current;
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach(track => track.stop());
      }
      setShowCameraModal(false);
      return; // no cierres todo el Drawer
    }
    setErrorsArticleImage(validateFormArticleImage());
    let errorsCheckArticleImage=validateFormArticleImage();
    if ((Object.keys(errorsCheckArticleImage).length === 0) && newArticleImage.titlees!=='' && newArticleImage.titleen!=='') {
     
     let updatedFiles = [];
      if (files.length > 0) {
        updatedFiles = await buildUpdatedFiles();
      }
      let imageToAdd = {
        "id" : newArticleImage.id, 
         "indexrowsarticleimage" : openEditNewArticleImage?newArticleImage.indexrowsarticleimage:formArticle.articleimages.length>0?formArticle.articleimages[formArticle.articleimages.length-1].indexrowsarticleimage+1:1,
        "titlees":newArticleImage.titlees,
        "titleen":newArticleImage.titleen,
        "filename" :  updatedFiles.length > 0?updatedFiles[0].filename:"", 
        "createdate" : updatedFiles.length > 0?updatedFiles[0].createdate:new Date(), 
        "datafile": updatedFiles.length > 0?updatedFiles[0].datafile:"", 
        "type" : updatedFiles.length > 0?updatedFiles[0].type:"" 
      }; 
      if (!openEditNewArticleImage){
        formArticle.articleimages.push(imageToAdd);
      }else{
        let idx=formArticle.articleimages.findIndex(((item) => item.indexrowsarticleimage === newArticleImage.indexrowsarticleimage));
        formArticle.articleimages[idx]=imageToAdd
      }
      setFormArticle(formArticle => ({
        ...formArticle,
      }))
      handleCloseNewArticleImage();
    }else{
      if (errorsArticleImage.titlees){
        dispatch(warningErrorAction(t(errorsCheckArticleImage.titlees)));
      }else{
        if (errorsArticleImage.titleen){
          dispatch(warningErrorAction(t(errorsCheckArticleImage.titleen)));
        }else{ 
          dispatch(warningErrorAction(t('Text_Error_Save_Data'))); 
        }
      }
    }  
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (showCameraModal && videoRef.current) {
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => {
          videoRef.current.srcObject = stream;
        })
        .catch(err => {
          dispatch(warningErrorAction(t('Text_CameraNotAccessible')));
          setShowCameraModal(false);
        });
    }
  }, [showCameraModal, dispatch, t]);

  useEffect(() => {
    if (openEditNewArticleImage ){
      setNewArticleImage(newArticleImage => ({
        ...newArticleImage,
        id:editRowArticleImage.id!==null?editRowArticleImage.id:"",
        indexrowsarticleimage:editRowArticleImage.indexrowsarticleimage!==null?editRowArticleImage.indexrowsarticleimage:1,
        titlees:editRowArticleImage.titlees!==null?editRowArticleImage.titlees:"",
        titleen:editRowArticleImage.titleen!==null?editRowArticleImage.titleen:"",
        filename : editRowArticleImage.filename!==null?editRowArticleImage.filename:"",
        createdate : editRowArticleImage.createdate!==null?editRowArticleImage.createdate:"",
        datafile : editRowArticleImage.datafile!==null?editRowArticleImage.datafile:"",
        type : editRowArticleImage.type!==null?editRowArticleImage.type:""
      }));

      // Si hay imagen previa, reconstruir File correcto a partir del base64
      if (editRowArticleImage.filename && editRowArticleImage.datafile && editRowArticleImage.type) {
        (async () => {
          const imageDataUrl = `data:${editRowArticleImage.type};base64,${editRowArticleImage.datafile}`;

          // Opción 1 (simple): usar fetch sobre el data URL para obtener un Blob
          const blob = await (await fetch(imageDataUrl)).blob();

          // Nota: lastModified debe ser número (ms desde epoch)
          const lastMod =
            editRowArticleImage.createdate
              ? new Date(editRowArticleImage.createdate).getTime()
              : Date.now();

          const file = new File([blob], editRowArticleImage.filename, {
            type: editRowArticleImage.type,
            lastModified: lastMod
          });

          setFiles([{ data: imageDataUrl, file }]);
        })();
      } else {
        setFiles([]);
      } 
    }else{
      setNewArticleImage(newArticleImage => ({
        ...newArticleImage,
        id:0,
        indexrowsarticleimage:0,
        titlees:"",
        titleen:"", 
        filename : "",
        createdate : new Date(),
        datafile : "",
        type :"" 
      }));
      setFiles([]);
    }
  },[editRowArticleImage,openEditNewArticleImage]);

  return(
    <>
      {openEditRowArticleImage && (
        <SwipeableDrawer
          anchor="right"
          open
          onClose={toggleDrawerNewArticleImage(false)}
          onOpen={toggleDrawerNewArticleImage(true)}
          PaperProps={{ sx: { width: 500 } }}
        >
          <Container sx={{ p: 2 }}>
            <Box sx={{ bgcolor: '#fff', height: '100vh', display: 'flex', flexDirection: 'column' }}>
              <Box id="myDIV" sx={{ px: 2, pt: 1 }}>
                <h1 className="h1NewStyle px-4 mb-2">
                  {openEditNewArticleImage ? t('Text_ArticleImage_Edit') : t('Text_ArticleImage_New')}
                </h1>
              </Box>
              <hr className="sidebar-divider d-none d-md-block" />
              <form onSubmit={handleCloseNewArticleImage}>
                <Box className="form-floating mb-3 primary" sx={{ px: 4 }}>
                  <div className="form-group">
                    <label className="text-primary">{t('Text_ArticleImage_Namees')} :</label>
                    <TextField
                      id="titlees"
                      name="titlees"
                      value={newArticleImage.titlees}
                      InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                      inputProps={{ style: { width: 410, fontSize: '18px' }, maxLength: 100 }}
                      label={errorsArticleImage.titlees != null ? t(errorsArticleImage.titlees) : t('PlaceHolder_ArticleImage_Namees')}
                      placeholder={t('PlaceHolder_ArticleImage_Namees')}
                      variant="standard"
                      onBlur={handleBlurNewArticleImage}
                      onChange={handleChangeNewArticleImage}
                    />
                  </div> 
                  <div className="form-group">
                    <label className="text-primary">{t('Text_ArticleImage_Nameen')} :</label>
                    <TextField
                      id="titleen"
                      name="titleen"
                      value={newArticleImage.titleen}
                      InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                      inputProps={{ style: { width: 410, fontSize: '18px' }, maxLength: 100 }}
                      label={errorsArticleImage.titleen != null ? t(errorsArticleImage.titleen) : t('PlaceHolder_ArticleImage_Nameen')}
                      placeholder={t('PlaceHolder_ArticleImage_Nameen')}
                      variant="standard"
                      onBlur={handleBlurNewArticleImage}
                      onChange={handleChangeNewArticleImage}
                    />
                  </div> 
                  <div className="form-group">
                    <label className="text-primary">
                      {t('Text_ArticleImage_Document')} : {newArticleImage.document}
                    </label>
                    <div className="upload-box" style={{ width: '100%' }}>
                      <img src={image1} alt="Camera Icon" style={{ width: 50, height: 50 }} />
                      <button type="button" className="btn-blue-outline" onClick={() => setShowCameraModal(true)} >
                        {t('Button_TakePhoto')}
                      </button>
                      <hr className="sidebar-divider d-none d-md-block" />
                      <DropzoneAreaBase
                        initialFiles={files}
                        fileObjects={files}
                        acceptedFiles={['image/*']}
                        maxFileSize={20000000}
                        filesLimit={1}
                        onAdd={handleAddFileImage}
                        onDelete={handleDeleteFileImage}
                        showAlerts={false}
                        dropzoneText={t('Text_Select_Image')}
                        showPreviews={false}
                        showPreviewsInDropzone={false}
                        showFileNamesInPreview={false}
                        showFileNames={false}
                        useChipsForPreview
                        previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                        previewChipProps={{ classes: { root: 'upload-preview-chip' } }}
                        classes={{
                          root: 'upload-dropzone-root',
                          icon: 'upload-dropzone-icon',
                          text: 'upload-dropzone-text',
                        }}
                      />
                    </div>
                    {files.length > 0 && (
                    <div className="preview-thumbnails-wrapper">
                      <div className="preview-thumbnails">
                        {files.map((fileObj, index) => (
                          <div key={index} className="thumbnail-container">
                            <img
                              src={fileObj.data}
                              alt={`preview-${index}`}
                              className="thumbnail-image"
                            /> 
                            <button
                              type="button"
                              onClick={() => handleDeleteFileImage(fileObj)}
                              className="thumbnail-delete-btn"
                              title={t('Text_Delete')}
                            >
                              &times;
                            </button> 
                            &nbsp;&nbsp;
                            <Chip
                              value={fileObj?.file?.name ?? 'captured-image.jpg'}
                              label={fileObj?.file?.name ?? 'captured-image.jpg'}
                              clickable={false}
                              style={{ color: '#e74a3b', fontSize: 14 }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}  
                  </div>
                  <hr className="sidebar-divider d-none d-md-block" />
                  <div className="formdi-pending-action-group">
                    <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitNewArticleImage}>
                      {openEditNewArticleImage?t('Button_Update'):t('Button_Create')}
                    </button> 
                    <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleCloseNewArticleImage}>
                      {t('Button_Cancel')}
                    </button>
                  </div>   
                </Box>
              </form>
            </Box> 
            {/* MODAL DE CÁMARA */}
            {showCameraModal && (
              <Box
                sx={{
                  position: 'absolute',   // 👈 antes: 'fixed'
                  inset: 0,               // ocupa todo el Paper del Drawer
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 10,             // por encima del contenido del Drawer
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    p: 2,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    maxWidth: 'min(90%, 520px)',
                    width: '100%',
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                    <video
                      ref={videoRef}
                      autoPlay
                      playsInline
                      width="320"
                      height="240"
                      style={{ borderRadius: '8px' }}
                    />
                    <canvas ref={canvasRef} style={{ display: 'none' }} />
                  </Box>

                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', width: '100%' }}>
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        const video = videoRef.current;
                        const canvas = canvasRef.current;
                        const ctx = canvas.getContext('2d');
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        const dataUrl = canvas.toDataURL('image/jpeg');
                        const file = dataURLtoFile(dataUrl, `camera-${Date.now()}.jpg`);
                        handleAddImage([{ data: dataUrl, file }]);
                        setShowCameraModal(false);
                        if (video.srcObject) video.srcObject.getTracks().forEach(t => t.stop());
                      }}
                    >
                      📸 {t('Button_Capture')}
                    </button>

                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        const video = videoRef.current;
                        if (video.srcObject) video.srcObject.getTracks().forEach(t => t.stop());
                        setShowCameraModal(false);
                      }}
                    >
                      ❌ {t('Button_Cancel')}
                    </button>
                  </Box>
                </Box>
              </Box>
            )}

          </Container>
        </SwipeableDrawer>
      )}
    </>
  )
}

ArticleImageCreateOrEditArticleImage.propTypes = {

  openEditRowArticleImage: PropTypes.bool.isRequired,
  setOpenEditRowArticleImage: PropTypes.func.isRequired,
  openEditNewArticleImage: PropTypes.bool.isRequired,
  setOpenEditNewArticleImage: PropTypes.func.isRequired,
  formArticle: PropTypes.object.isRequired,
  setFormArticle: PropTypes.func.isRequired, 
  setEditRowArticleImage: PropTypes.func.isRequired
};

export default ArticleImageCreateOrEditArticleImage;